import { useQuery } from '@apollo/client';
import { Col, Row } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

import { FormItemInputText } from '../../../components/forms/basicFormElements';
import { JobLocationSection } from '../newShipment/newShipmentElements';
import {
  fromServerDateOptional,
  toServerDateOptional,
} from '../../../common/utils/dateUtils';
import { FormItemDatePicker } from '../../../components/forms/dateElements';
import { AIRLINES_QUERY } from '../../../app/graphql/jobQueries';
import AirlineAutoComplete from './components/AirlineAutoComplete';
import SearchFlightFormItem from './components/SearchFlightsButton';

export default function AirRetrievalFlight({ className }) {
  const { formatMessage } = useIntl();
  const { data, loading } = useQuery(AIRLINES_QUERY);

  return (
    <div className={className}>
      <Row justify="end">
        <SearchFlightFormItem disabled={loading} />
      </Row>
      <Row gutter={20}>
        <Col span={16}>
          <JobLocationSection
            titleId="book.newAirRetrieval.airline"
            requiredInTitle
          >
            <AirlineAutoComplete
              name="flightAirline"
              airlines={data?.getAirlines || []}
              rules={[{ required: true }]}
              isLoading={loading}
            />
          </JobLocationSection>
        </Col>
        <Col span={4}>
          <JobLocationSection
            titleId="book.newAirRetrieval.flightNumber"
            requiredInTitle
          >
            <FormItemInputText
              name="flightNumber"
              placeholder={formatMessage({
                id: 'book.newAirRetrieval.flightNumber.placeholder',
              })}
              floatingLabel={false}
              rules={[{ required: true }]}
            />
          </JobLocationSection>
        </Col>
        <Col span={4}>
          <JobLocationSection
            titleId="book.newAirRetrieval.departure"
            requiredInTitle
          >
            <FormItemDatePicker
              name="flightDeparture"
              floatingLabel={false}
              rules={[{ required: true }]}
              formItemComponentProps={{
                formatValue: fromServerDateOptional,
                parseValue: toServerDateOptional,
              }}
            />
          </JobLocationSection>
        </Col>
      </Row>
    </div>
  );
}
